import request from "@/plugin/request";

export const get = (queryParams = {}, page = {
    size: 100,
    current: 1
}) => request.post('/assetFlow/getList', {
    page, queryParams
})